/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CashBoxReplacementHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxReplacementTabAction,
    CashBoxReplacementTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxReplacementTabActions';

export interface CashBoxReplacementTabState {
    cashBoxReplacementHistory: CashBoxReplacementHistoryDto;
    isLoadingReplacementHistory: boolean;
    isDownloadingReplacementHistory: boolean;
}
const initialState: CashBoxReplacementTabState = {
    cashBoxReplacementHistory: null,
    isLoadingReplacementHistory: false,
    isDownloadingReplacementHistory: false,
};

export function cashBoxReplacementTabReducer(
    state: CashBoxReplacementTabState = initialState,
    action: CashBoxReplacementTabAction,
): CashBoxReplacementTabState {
    switch (action.type) {
        case CashBoxReplacementTabActionType.FETCH_CASHBOX_REPLACEMENT_HISTORY:
            return {
                ...state,
                isLoadingReplacementHistory: true,
            };

        case CashBoxReplacementTabActionType.FETCH_CASHBOX_REPLACEMENT_HISTORY_SUCCESS:
            return {
                ...state,
                cashBoxReplacementHistory: action.payload,
                isLoadingReplacementHistory: false,
            };

        case CashBoxReplacementTabActionType.FETCH_CASHBOX_REPLACEMENT_HISTORY_ERROR:
            return {
                ...state,
                isLoadingReplacementHistory: false,
                cashBoxReplacementHistory: {
                    parents: null,
                    children: null,
                },
            };

        case CashBoxReplacementTabActionType.DOWNLOAD_REPLACEMENT_HISTORY:
            return {
                ...state,
                isDownloadingReplacementHistory: true,
            };

        case CashBoxReplacementTabActionType.DOWNLOAD_REPLACEMENT_HISTORY_SUCCESS:
        case CashBoxReplacementTabActionType.DOWNLOAD_REPLACEMENT_HISTORY_ERROR:
            return {
                ...state,
                isDownloadingReplacementHistory: false,
            };

        case CashBoxReplacementTabActionType.EXIT_CASHBOX_REPLACEMENT_TAB:
            return {
                ...state,
                cashBoxReplacementHistory: null,
            };

        default:
            break;
    }
    return state;
}
